import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JwtService } from 'app/generic/JwtService';
import { NewModalService } from 'app/generic/new-modal/new-modal.service';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CusSatService extends JwtService {

  constructor(private http: HttpClient,
    public router: Router,
    public modalComponent: NewModalService) {
    super(router, modalComponent);
  }


  insertVote(voto:any): Promise<any> {
    return this.http.post(environment.apiEndpoint+'/CentroFunzionalePortaleRest/rest/vote/insert', voto, super.getOptions()).toPromise().then(
      res => res).catch(this.handleError.bind(this));
  }

  updateVote(voto:any): Promise<any> {
    return this.http.post(environment.apiEndpoint+'/CentroFunzionalePortaleRest/rest/vote/update', voto, super.getOptions()).toPromise().then(
      res => res).catch(this.handleError.bind(this));
  }

}
